export const URL_ENTITY_TYPES: Record<string, string> = {
  GENE: "gene",
  CONTIG: "contig",
  TRANSCRIPT: "transcript",
  PROTEIN: "protein",
  SEQUENCE: "sequence",
  GENERIC_SEQ: "genericSeq",
  TRANSCRIPT_LOCATION: "transcriptLocation",
  PROTEIN_LOCATION: "proteinLocation",
  PROBE: "probe",
  OTHER: "otherDna",
  ORGANISM: "organism",
  USER: "user",
  ORTHOLOG: "ortholog",
  DIRECTIONAL_ORTHOLOG: "directionalOrtholog",
  VARIANT: "variant",
  VCF_VARIANT: "vcfVariant",
  MUTATION: "mutation",
  GENE_MUTATION: "geneMutation",
  PROTEIN_MUTATION: "proteinMutation",
  VIEW: "view",
  REGION_FLAG: "regionFlag",
  QUERY: "query",
  BLAST_HIT: "blastHit",
  BLAST_HSP: "blastHsp",
  SAMPLE: "sample",
  SAMPLE_PARENT: "parent",
  NUFEATURE: "nuFeature",
  AAFEATURE: "aaFeature",
  SAMPLE_REPORT: "report",
  SAMPLE_ATTRIBUTE: "attribute",
  SAMPLE_TYPE: "sampleType",
  PATHWAY: "pathway",
  GENOMEASSEMBLY: "genomeAssembly",
  ANALYST_SESSION: "ssaSession",
  WORKFLOW_SESSION: "sswSession",
  ARRAY_SESSION: "sssSession",
  ANALYSIS_GROUP: "analysisGroup",
  MARKER: "marker",
  MARKER_NUS: "markerNus",
  EVENT: "playbookEvent",
  PROJECT: "project",
  PLAYBOOK: "playbook",
  BED_FEATURE: "bed",
  COORD_LIST: "coordinateList",
  COORDINATE: "coordinate",
  WORKFLOW: "workflow",
  PROJECT_FILE: "projectFile",
  PARENT_TYPE: "parentType",
};
